module.exports = __webpack_public_path__ + "static/media/img-keelo-screen.60fd8086.png";